import { render, staticRenderFns } from "./LaneClosureRequestContraventionList.vue?vue&type=template&id=068b32da&"
import script from "./LaneClosureRequestContraventionList.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestContraventionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports